<template>
  <div class="app-container">
    <el-card shadow="never">
      <!-- header -->
      <!-- <div slot="header">
        <span>账户列表</span>
      </div> -->
      <div>
        <div class="searchContainer">
          <el-dropdown
            trigger="click"
            @command="getURLData"
          >
            <el-button
              type="primary"
              class="filter-item"
              style="margin-right: 10px;max-height: 36px;"
            >授权</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="'微信'">微信</el-dropdown-item>
              <el-dropdown-item :command="'QQ'">QQ</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-button
            class="filter-item"
            type="primary"
            @click="(typeValue = 'MP扫码登录') && $refs.codeScanning.open()"
          >
            MP扫码登录
          </el-button>

          <el-button
            class="filter-item"
            type="primary"
            @click="(typeValue = 'ADQ扫码登录') && $refs.codeScanning.open()"
          >
            ADQ扫码登录
          </el-button>

          <el-button
            type="primary"
            class="filter-item"
            style="max-height: 36px;"
            @click="(typeValue = '同步备注') && $refs.codeScanning.open()"
          >同步备注</el-button>
        </div>
        <div class="searchContainer">
          <label class="inputLabel">账号ID：</label>
          <el-input
            v-model="advertisersQuery.account_id"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label class="inputLabel">账号名称：</label>
          <el-input
            v-model="advertisersQuery.account_name"
            placeholder="请输入内容"
          />
        </div>
        <div class="searchContainer">
          <label for="searchword">账号类型：</label>
          <el-select
            v-model="advertisersQuery.type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in accountType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="searchContainer">
          <label for="searchword">账号状态：</label>
          <el-select
            v-model="advertisersQuery.account_status"
            placeholder="请选择"
          >
            <el-option-group
              v-for="group in options"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-option-group>
          </el-select>
        </div>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
        >
          搜索
        </el-button>
        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-refresh"
          @click="handleSearchReset"
        >
          重置
        </el-button>

        <el-button
          class="filter-item"
          type="primary"
          icon="el-icon-s-help"
          @click="eliminate"
        >
          清除账号
        </el-button>
        <el-dropdown
          trigger="click"
          style="margin: 0 5px"
        >
          <el-button type="success">
            更多批量操作<i class="el-icon-arrow-down el-icon--right" />
          </el-button>
          <el-dropdown-menu
            slot="dropdown"
            style="text-align: center;"
          >
            <el-dropdown-item style="margin-bottom: 10px;"><el-button
              icon="el-icon-download"
              type="success"
              @click="pullAll"
            >批量拉取素材报表</el-button></el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;"><el-button
              icon="el-icon-edit-outline"
              type="warning"
              @click="editepiwek"
            >批量修改备注</el-button></el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;"> <el-button
              icon="el-icon-edit-outline"
              type="warning"
              @click="editeptag"
            >批量修改标签</el-button></el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;"><el-button
              type="warning"
              :disabled="isShow2"
              @click="deleteADList"
            >批量暂停广告</el-button></el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;"> <el-button
              type="warning"
              :disabled="isShow2"
              @click="editPriceList"
            >批量修改出价/roi/投放日期/投放时间</el-button></el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="warning"
                :disabled="isShow2"
                @click="editPeoplesList"
              >批量修改排除人群包</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="danger"
                :disabled="isShow2"
                @click="deleteAd"
              >批量删除广告</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="warning"
                @click="link"
              >批量修改行为数据源</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="warning"
                @click="BatchRecording"
              >行为数据源修改记录</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="warning"
                :disabled="isShow2"
                @click="Batchremoval"
              >批量移除区域</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px">
              <el-button
                type="warning"
                :disabled="isShow2"
                @click="upbAdFeekBack"
              >批量修改监测链接</el-button>
            </el-dropdown-item>
            <el-dropdown-item style="margin-bottom: 10px;">
              <el-button
                type="warning"
                @click="upbAdLog"
              >广告批量修改记录</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button
                type="warning"
                @click="openDelAdsByProductLog"
              >删除产品广告</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          class="filter-item"
          type="danger"
          @click="management"
        >
          违规单据（精准处罚）
        </el-button>
        <el-button
          class="filter-item"
          type="danger"
          @click="billmeasure"
        >
          违规单据（计量处罚）
        </el-button>
        <el-button
          class="filter-item"
          type="warning"
          @click="exportQuery"
        >
          导出
        </el-button>
        <el-button
          v-if="showExportButton"
          class="filter-item"
          type="warning"
          @click="exportmoneylist"
        >
          导出资金流水
        </el-button>
        <el-button
          class="filter-item"
          type="success"
          @click="realnametoken"
        >
          实名令牌(
          {{
            shiobj.status === 1
              ? shiobj.expire_time
              : shiobj.status === 2
                ? '已过期'
                : '未获取'
          }}
          )
        </el-button>
        <!-- <el-button
          icon="el-icon-download"
          class="filter-item"
          type="success"
          @click="pullAll"
        >批量拉取素材报表</el-button>
        <el-button
          icon="el-icon-edit-outline"
          class="filter-item"
          type="warning"
          @click="editepiwek"
        >批量修改备注</el-button>
        <el-button
          icon="el-icon-edit-outline"
          class="filter-item"
          type="warning"
          @click="editeptag"
        >批量修改标签</el-button>
        <el-button
          class="filter-item"
          type="warning"
          :disabled="isShow2"
          @click="deleteADList"
        >批量暂停广告</el-button>
        <el-button
          class="filter-item"
          type="warning"
          :disabled="isShow2"
          @click="editPriceList"
        >批量修改出价/roi</el-button>
        <el-button
          class="filter-item"
          type="warning"
          :disabled="isShow2"
          @click="editPeoplesList"
        >批量修改排除人群包</el-button>
        <el-button
          class="filter-item"
          type="danger"
          :disabled="isShow2"
          @click="deleteAd"
        >批量删除广告</el-button>
        <el-button
          class="filter-item"
          type="warning"
          @click="link"
        >批量修改行为数据源</el-button>
        <el-button
          class="filter-item"
          type="warning"
          @click="BatchRecording"
        >批量记录</el-button> -->
        <!-- <el-button
          icon="el-icon-plus"
          class="filter-item"
          type="warning"
          @click="addadvr"
        >新增</el-button> -->
      </div>
      <el-table
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        class="border-gray"
        fit
        style="width: 100%; justify-content: space-between;margin-top:20px"
        :row-key="getRowKeys"
        max-height="800"
        @select="multipleChoice"
        @select-all="multipleChoice"
      >
        <el-table-column
          v-if="true"
          type="selection"
          width="55"
          :data-index="1"
          :reserve-selection="true"
        />
        <el-table-column
          prop="account_name"
          label="广告主名称"
          width="200"
        >
          <template scope="scope">
            <div>
              <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{ scope.row.account_name }}</span>
              <input
                v-else
                v-model="activeText"
                autofocus
                style="width: 300px;padding: 5px;border: 1px solid #ccc;"
                @blur="blur1"
              >
              <i
                v-if="!(activeItem && activeItem.id === scope.row.id)"
                class="el-icon-edit"
                style=" margin-left: 13px; font-size: 19px; cursor: pointer;"
                @click="(activeItem = scope.row),(activeText = scope.row.account_name)"
              />
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column
          prop="note_name"
          label="备注"
        /> -->
        <el-table-column
          prop="remark"
          label="备注"
          width="200"
        >
          <template scope="scope">
            <div>
              <span v-if="!(remarkItemId && remarkItemId.id === scope.row.id)">{{ scope.row.remark }}</span>
              <input
                v-else
                v-model="remarkTextid"
                autofocus
                style="width: 300px;padding: 5px;border: 1px solid #ccc;"
                @blur="blur3"
              >
              <i
                v-if="!(remarkItemId && remarkItemId.id === scope.row.id)"
                class="el-icon-edit"
                style=" margin-left: 13px; font-size: 19px; cursor: pointer;"
                @click="(remarkItemId = scope.row),(remarkTextid = scope.row.remark)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="标签"
          width="200"
        >
          <template scope="scope">
            <div>
              <span v-if="!(tagItemId && tagItemId.id === scope.row.id)">{{ scope.row.tag }}</span>
              <input
                v-else
                v-model="tagTextid"
                autofocus
                style="width: 300px;padding: 5px;border: 1px solid #ccc;"
                @blur="blur4"
              >
              <i
                v-if="!(tagItemId && tagItemId.id === scope.row.id)"
                class="el-icon-edit"
                style=" margin-left: 13px; font-size: 19px; cursor: pointer;"
                @click="(tagItemId = scope.row),(tagTextid = scope.row.tag)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="account_id"
          label="账号ID"
          width="170"
        >

          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.account_id"
            >{{ scope.row.account_id }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="service_name"
          label="服务商"
        />
        <el-table-column
          prop="wechat_account_id"
          label="AppID"
          width="200"
        >
          <template scope="scope">
            <div>
              <span v-if="!(activeItemId && activeItemId.id === scope.row.id)">{{ scope.row.wechat_account_id }}</span>
              <input
                v-else
                v-model="activeTextid"
                autofocus
                style="width: 300px;padding: 5px;border: 1px solid #ccc;"
                @blur="blur2"
              >
              <i
                v-if="!(activeItemId && activeItemId.id === scope.row.id)"
                class="el-icon-edit"
                style=" margin-left: 13px; font-size: 19px; cursor: pointer;"
                @click="(activeItemId = scope.row),(activeTextid = scope.row.wechat_account_id)"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="account_status_text"
          label="账号状态"
          width="170"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.account_status_text"
            >{{ scope.row.account_status_text }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="type"
          label="账号类型"
        >
          <template scope="scope">
            <span>{{ scope.row.type === 1 ? '微信' : '腾讯广告' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="money"
          label="账户余额(元)"
          align="center"
        >
          <template scope="scope">
            <el-button
              type="text"
              :loading="moneyLoading"
            />
            <span v-show="!moneyLoading">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop=""
          label="预计消耗(元)"
        />
        <el-table-column
          prop="advertiser_detail"
          label="昨日消耗"
          width="170"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.advertiser_detail.zuotian"
            >{{ scope.row.advertiser_detail.zuotian }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="advertiser_detail"
          label="今日消耗"
          width="170"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.advertiser_detail.jintian"
            >{{ scope.row.advertiser_detail.jintian }}</p>
          </template>
        </el-table-column>
        <el-table-column
          prop="advertiser_relation"
          label="运营人员"
          width="200"
        >
          <template scope="scope">
            <p
              class="overflow"
              :title="scope.row.advertiser_relation.map(item => item.relation_name).join('、')"
            >
              {{ scope.row.advertiser_relation.map(item => item.relation_name).join('、') }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          prop="advertiser_relation"
          label="主要运营人员"
        >
          <template scope="scope">
            <p>{{ scope.row.advertiser_relation | filterMaster }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-dropdown
              trigger="click"
              @command="(command)=>handleCommand(command,scope.row)"
            >
              <span
                class="el-dropdown-link"
                style="cursor: pointer;"
              >
                更多
                <i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item>
                  <router-link :to="{path:'/customer/accountList/createAdvert/index', query: {account_id: scope.row.account_id}}">
                    投放广告
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.type === 1">
                  <router-link :to="{path:'/nativePAGE', query: {account_id: scope.row.account_id}}">
                    原生页
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.type === 2">
                  <router-link :to="{path:'/landingPage', query: {account_id: scope.row.account_id}}">
                    落地页
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item>
                  <router-link :to="{path:'/customer/accountList/advertiserDirectionPackage/index', query: {account_id: scope.row.account_id, fetchDataflag: 'flag'}}">
                    定向包管理
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item>
                  <router-link :to="{path:'/customer/bindingMaterial/index', query: {account_id: scope.row.account_id}}">
                    绑定素材库
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item v-if="scope.row.type === 2">
                  <router-link :to="{path:'/customer/accountList/tencentAdqAdvertManage/index', query: {account_id: scope.row.account_id, fetchDataflag: 'adq'}}">
                    创建adq广告
                  </router-link>
                </el-dropdown-item> -->
                <el-dropdown-item>
                  <router-link
                    :to="{
                      path: `/tencentAD/adList/index`,
                      query: {
                        account_id: scope.row.account_id,
                        account_name: scope.row.account_name,
                        service_name: scope.row.service_name ? scope.row.service_name : '无'
                      }
                    }"
                  >
                    复制广告
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="zijinzhanghu(scope.row)">资金账户</div>
                </el-dropdown-item>
                <!-- <el-dropdown-item command="dataReport">
                  数据报告
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.type === 1">
                  <router-link
                    :to="{
                      path:`/customer/accountList/tencentAdqAdvertManage/CopyNativePAGE/index.vue`,
                      query: {
                        account_id: scope.row.account_id,
                        account_name: scope.row.account_name,
                        service_name: scope.row.service_name ? scope.row.service_name : '无'
                      }
                    }"
                  >
                    复制原生页
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                    :to="{
                      path: `/customer/echoList/index.vue`,
                      query: {
                        account_id: scope.row.account_id,
                        wechat_account_id: scope.row.wechat_account_id,
                        account_name:scope.row.account_name
                      }
                    }"
                  >
                    回传配置
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="scope.row.type === 2">
                  <router-link
                    :to="{
                      path: `/customer/accountList/enterpriseAndMicroCustomer`,
                      query: {
                        account_id: scope.row.account_id,
                        wechat_account_id: scope.row.wechat_account_id,
                        account_name: scope.row.account_name
                      }
                    }"
                  >
                    企微客服
                  </router-link>
                </el-dropdown-item> -->
                <!-- <el-dropdown-item v-if="scope.row.type === 1">
                  <router-link :to="{path:'/accountAdvertising', query: {account_id: scope.row.account_id}}">
                    创建mp广告
                  </router-link>
                </el-dropdown-item>

                <el-dropdown-item>
                  <router-link :to="{path:'/planAccount', query: {account_id: scope.row.account_id}}">
                    推广计划
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link
                    v-if="scope.row.type === 2"
                    :to="{path:'/customer/accountList/tencentAdqAdvertManage/BrandImage', query: {account_id: scope.row.account_id}}"
                  >品牌形象</router-link>
                </el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-right
        :total="total"
        :page-sizes="pageSize"
        :page-size="30"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
      <!-- <global-window title="授权" :visible.sync="dialogVisible" display="table" width="1000px" @close="closeDialog" @confirm="closeDialog">
        <iframe
          v-show="authorizeURLData === null ? false : true"
          width="800"
          height="600"
          marginwidth="0"
          marginheight="0"
          frameborder="0"
          :src="authorizeURLData"
        />
      </global-window> -->
    </el-card>
    <CodeScanning
      ref="codeScanning"
      :title="typeValue === 'QQ' ? 'QQ扫码授权' : typeValue === '微信' ? '微信扫码授权' : typeValue "
      :myobj="mStyle[typeValue] || {}"
      @openedEnd="openedEnd"
      @reset="reset"
    />
    <el-dialog
      title="批量拉取"
      :visible.sync="dialogVisiblePull"
      width="600px"
      :before-close="handleClose"
    >
      <detailsList
        ref="pull"
        @addPull="addPull"
      />
    </el-dialog>
    <el-dialog
      title="广告"
      :visible.sync="dialogVisibleadr"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <addAD
        ref="addadview"
        @updata="updata"
      />
    </el-dialog>
    <el-dialog
      title="批量修改备注"
      :visible.sync="dialogVisibleremark"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <choosedialog
        ref="choosedialogview"
        @companycallback="companycallback"
      />
    </el-dialog>
    <el-dialog
      title="批量修改标签"
      :visible.sync="dialogVisibletag"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="600px"
    >
      <choosetagdialog
        ref="choosetagdialogview"
        @tagcompanycallback="tagcompanycallback"
      />
    </el-dialog>
    <el-dialog
      title="确定停止以下广告吗?"
      :visible.sync="del_ad_visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div>
        <el-tag
          v-for="item in account_item"
          :key="item.account_id"
          closable
          style="margin:5px"
          @close="delAd(item)"
        >{{ item.account_name }}({{ item.account_id }})</el-tag>
      </div>
      <div style="margin-top: 10px">
        <el-button
          type="success"
          :loading="buto_loading"
          @click="commitDelIds"
        >确定</el-button>
      </div>
    </el-dialog>
    <edit-price-dialog
      :visible.sync="ed_price_visible"
      :account-item="account_item"
      :account-ids="account_ids"
      @remove="delAd"
      @success="handleEditPriceSuccess"
    />
    <el-dialog
      title="确定修改排除人群包吗?"
      :visible.sync="ed_peo_visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="max-height: 200px;overflow-y: auto;">
        <el-tag
          v-for="item in account_item"
          :key="item.account_id"
          closable
          style="margin:5px"
          @close="delAd(item)"
        >{{ item.account_name }}({{ item.account_id }})</el-tag>
      </div>
      <el-input
        v-model="custom_ids"
        type="textarea"
        :rows="6"
        style="margin-top: 20px"
        placeholder="请输入排除人群包，输入多个请用英文逗号隔开"
        @blur="emblur"
      />
      <div style="margin-top: 10px">
        <el-button
          type="success"
          :loading="buto_loading"
          @click="updAdCustom"
        >确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="确定批量删除广告吗?"
      :visible.sync="del_visible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <div style="max-height: 200px;overflow-y: auto;">
        <el-tag
          v-for="item in account_item"
          :key="item.account_id"
          closable
          style="margin:5px"
          @close="delAd(item)"
        >{{ item.account_name }}({{ item.account_id }})</el-tag>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="del_visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="delAdCustom"
        >确定</el-button>
      </div>
      <el-dialog
        title="填写密码"
        :visible.sync="password_visible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        width="400px"
        append-to-body
      >
        <p style="color: red;font-size: 19px">*该操作会删除选择的广告主下所有的广告</p>
        请输入密码:
        <el-input
          v-model="mima"
          style="margin-top: 20px;width: 280px"
          placeholder="请填写密码"
          show-password
        />
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="success"
            :loading="buto_loading"
            @click="passwordCommit"
          >提交</el-button>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog
      title="资金账户"
      :visible.sync="fund_visible"
      :destroy-on-close="true"
    >
      <el-table
        :data="fund_table_data"
        border
      >
        <el-table-column
          prop="fund_type_text"
          label="资金账户类型"
        />
        <el-table-column
          prop="balance"
          label="余额"
        />
        <el-table-column
          prop="bill_deposit_amount"
          label="锁定金额"
        />
        <el-table-column
          prop="fund_status_text"
          label="资金状态"
        />
        <el-table-column
          prop="realtime_cost"
          label="今日消耗"
        />
      </el-table>
    </el-dialog>
    <el-dialog
      title="批量移除区域"
      :visible.sync="batchremovaldialogVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <bathremovacompant
        ref="bathremovacompantview"
        @callbatchremova="callbatchremova"
      />
    </el-dialog>
    <el-dialog
      title="批量修改监测链接"
      :visible.sync="updAdFeedbackVisible"
      width="30%"
      :destroy-on-close="true"
    >
      <updAdFeedback
        ref="updAdFeedback"
        @updAdFeedback="updAdFeedback"
      />
    </el-dialog>
    <el-dialog
      title="批量修改记录"
      :visible.sync="upd_ad_log_visible"
      width="60%"
      :destroy-on-close="true"
    >
      <upd-ad-log />
    </el-dialog>
    <el-dialog
      title="导出资金流水"
      :visible.sync="upd_monrylist"
      width="25%"
      :destroy-on-close="true"
    >
      <exportmonrylist @fundupdata="fundupdata" />
    </el-dialog>
    <el-dialog
      title="实名令牌"
      :visible.sync="realnametokendialog"
      width="45%"
      :destroy-on-close="true"
    >
      <iframe :src="tokeniframe" style="width: 100%;height: 700px;" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
// import AdminAdvertAdd from './components/AdminAdvertAdd.vue'
import {
  advertiserList,
  getQrCode,
  eliminate,
  change_name,
  change_app_id,
  advertisers,
  account_mchange_remark,
  account_mchange_tag,
  stopCopyAd,
  updAdCustom,
  delAdCustom,
  getFunds,
  exportAccount
} from '@/api/customer.js'
import { getURL, getBalance, qqShouQuan, syncNotes, adqShouQuan, userauthorizeurl, userauthorizeexpire } from '@/api/report/accountManagement'
// import GlobalWindow from '@/components/GlobalWindow.vue'
import detailsList from './components/details.vue'

import CodeScanning from './codeScanningLogin/index.vue'
import addAD from './tencentAdqAdvertManage/addAD/index.vue'
import choosedialog from './components/choosedialog.vue'
import choosetagdialog from './components/choosetagdialog'
import axios from 'axios'
import md5 from 'js-md5'
import bathremovacompant from './components/bathremovacompant.vue'
import UpdAdFeedback from '@/views/tencentAD/accountList/components/updAdFeedback.vue'
import UpdAdLog from '@/views/tencentAD/accountList/components/updAdLog.vue'
import exportmonrylist from '@/views/tencentAD/accountList/components/exportmonrylist.vue'
import EditPriceDialog from '@/views/tencentAD/accountList/components/editPriceDialog.vue'
import { getInfo } from '@/api/user'
const mStyle = {
  QQ: {
    left: '-119px',
    top: '-76px',
    width: '424px'
  },
  微信: {
    left: '-189px',
    top: '-43px',
    width: '568px'
  },
  MP扫码登录: {
    top: '-45px',
    left: '-189px',
    width: '568px'
  },
  同步备注: {
    top: '-100px',
    left: '-189px',
    width: '568px'
  },
  ADQ扫码登录: {
    top: '-139px',
    left: '-341px',
    width: '888px'
  }
}

export default {
  name: 'AccountList',
  components: {
    UpdAdLog,
    UpdAdFeedback,
    PaginationRight,
    CodeScanning,
    detailsList,
    addAD,
    choosedialog,
    choosetagdialog,
    bathremovacompant,
    exportmonrylist,
    EditPriceDialog
    // AdminAdvertAdd
  },
  filters: {
    // 用于过滤主要运营人员 如果 is_master 为 1 则 relation_name 就是主要运营成员
    filterMaster(currentData) {
      for (let i = 0; i < currentData.length; i++) {
        if (currentData[i].is_master === 1) {
          return currentData[i].relation_name
        }
      }
    }
  },
  data() {
    return {
      roi_type: '1',
      tableData: [],
      search: {},
      total: null, // 数据总条数啊
      pageSize: [10, 20, 30, 50, 100, 200],
      // table列表数据请求参数
      advertisersQuery: {
        account_id: null,
        account_name: null,
        type: null,
        account_status: null,
        page: null, // 当前页码
        page_size: 30// 显示数据条数
      },
      // 枚举值请求参数
      enumerationsQuery: {
        account_id: null,
        api_name: 'account_management/advertisers'
      },
      // 账号类型
      accountType: [
        {
          value: 1,
          label: '微信公众号'
        },
        {
          value: 2,
          label: '腾讯广告(adq)'
        }
      ],
      options: [
        {
          label: '腾讯', // 客户系统状态 枚举值
          options: [
            {
              value: 'CUSTOMER_STATUS_NORMAL',
              label: '有效'
            },
            {
              value: 'CUSTOMER_STATUS_PENDING',
              label: '待审核'
            },
            {
              value: 'CUSTOMER_STATUS_DENIED',
              label: '审核不通过'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN',
              label: '封停'
            },
            {
              value: 'CUSTOMER_STATUS_FROZEN_TEMPORARILY',
              label: '临时冻结'
            }
          ]
        },
        {
          label: '微信', // 微信广告账户授权状态 枚举值
          options: [
            {
              value: 'STATUS_PRE_AUTHORIZATION',
              label: '预授权'
            },
            {
              value: 'STATUS_CONFIRM_AUTHORIZATION',
              label: '确认授权/已绑定'
            },
            {
              value: 'STATUS_REQUEST_CANCELATION',
              label: '请求撤销授权'
            }
          ]
        }
      ],
      accountIdsQuery: [], // 获取用户余额的参数
      loading: false, // 加载动画
      dialogVisible: false,
      dialogVisiblePull: false,
      moneyLoading: false, // 余额加载动画
      mantle: false,
      source: null,
      typeValue: '',
      mStyle: mStyle,
      activeItem: null,
      activeItemId: null,
      activeText: null,
      activeTextid: null,
      dialogVisibleadr: false,
      remarkItemId: null,
      remarkTextid: null,
      dialogVisibleremark: false,
      tagItemId: null,
      tagTextid: null,
      dialogVisibletag: false,
      account_ids: [],
      account_item: [],
      del_ad_visible: false,
      ed_price_visible: false,
      ed_peo_visible: false,
      del_visible: false,
      custom_ids: [],
      buto_loading: false,
      mima: null,
      password_visible: false,
      fund_visible: false,
      fund_table_data: [],
      batchremovaldialogVisible: false,
      updAdFeedbackVisible: false,
      upd_ad_log_visible: false,
      upd_monrylist: false,
      userIfon: {},
      tokeniframe: '',
      realnametokendialog: false,
      shiobj: {}
    }
  },
  computed: {
    isShow2() {
      return this.account_ids.length === 0
    },
    showExportButton() {
      const user = this.userIfon
      if (!user) return false

      // 条件1：is_root 为 1
      if (user.is_root === 1) return true

      // 条件2：groups 里有 title 等于 "数据分析"
      if (Array.isArray(user.groups)) {
        return user.groups.some(g => g.title === '数据分析')
      }

      return false
    }
  },
  created() {
    this.getAdvertiserList()
    this.dfawerqw()
    getInfo().then(data => {
      this.userIfon = data.data
      console.log('this.userIfon', this.userIfon)
    })
  },
  methods: {
    async addPull(obj) {
      console.log('obj:', obj)
      await advertisers(obj)
      this.$message.success('批量拉取成功')
      this.dialogVisiblePull = false
    },
    handleClose() {
      this.dialogVisiblePull = false
    },
    pullAll() {
      this.dialogVisiblePull = true
      this.$nextTick(() => {
        this.$refs.pull.sendr()
      })
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await change_name({ id: this.activeItem.id, account_name: this.activeText })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    async blur2() {
      if (this.activeItemId.consume !== this.activeTextid) {
        try {
          await change_app_id({ id: this.activeItemId.id, app_id: this.activeTextid })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.activeItemId = null
          this.activeTextid = null
        }
      }
      this.activeItemId = null
      this.activeTextid = null
    },
    async blur3() {
      if (this.remarkItemId.consume !== this.remarkTextid) {
        try {
          await account_mchange_remark({ account_ids: [this.remarkItemId.account_id], remark: this.remarkTextid })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.remarkItemId = null
          this.remarkTextid = null
        }
      }
      this.remarkItemId = null
      this.remarkTextid = null
    },
    async blur4() {
      if (this.tagItemId.consume !== this.tagTextid) {
        try {
          await account_mchange_tag({ account_ids: [this.tagItemId.account_id], tag: this.tagTextid })
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.getAdvertiserList()
        } catch (err) {
          this.tagItemId = null
          this.tagTextid = null
        }
      }
      this.tagItemId = null
      this.tagTextid = null
    },
    getAdvertiserList() {
      this.loading = true
      advertiserList(this.advertisersQuery).then(res => {
        this.tableData = res.data.list
        this.total = res.data.total
        for (let i = 0; i < res.data.list.length; i++) {
          this.accountIdsQuery[i] = res.data.list[i].account_id
        }
        this.loading = false
        res.data.list.length > 0 && this.getBalanceData()
        // this.tableData[0].advertiser_relation[0].is_master = 1
      })
    },
    getURLData(item) {
      this.dialogVisible = true
      if (item === '微信') {
        getURL().then(res => {
          window.open(res.data.advertiser)
        })
      } else {
        this.typeValue = 'QQ'
        this.$refs.codeScanning.open()
      }
    },
    // 获取用户余额
    getBalanceData() {
      this.moneyLoading = true
      getBalance({ account_ids: this.accountIdsQuery.toString() }).then(res => {
        const arr = []
        for (let i = 0; i < res.data.length; i++) {
          arr[i] = res.data[i].account
        }
        for (let i = 0; i < this.tableData.length; i++) {
          const index = arr.indexOf(this.tableData[i].account_id)
          if (index !== -1) {
            this.tableData[i].money = res.data[index].balance
          }
        }
        this.accountIdsQuery = []
        this.moneyLoading = false
      })
    },
    // 关闭iframe
    closeDialog() {
      this.dialogVisible = false
      this.authorizeURLData = null
    },
    // 抓取分页数据
    fetchPageSize(data) {
      this.advertisersQuery.page_size = data
      this.getAdvertiserList()
    },
    // 抓取当前页数据
    fetchCurrentPage(data) {
      this.advertisersQuery.page = data
      this.getAdvertiserList()
    },
    // 搜索
    handleSearch() {
      this.advertisersQuery.page = 1
      this.getAdvertiserList()
    },
    // 重置搜索框
    handleSearchReset() {
      this.advertisersQuery = {}
      this.getAdvertiserList()
    },
    handleCommand(command, data) {
      switch (command) {
        case 'dataReport':
          this.$router.push({
            name: 'EffectData',
            params: { account_id: data.account_id, account_name: data.account_name }
          })
          break
      }
    },
    async openedEnd(callback) {
      let src = null
      try {
        if (this.typeValue === 'MP扫码登录') {
          const data = await getQrCode({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'QQ') {
          const data = await qqShouQuan({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === '同步备注') {
          const data = await syncNotes({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        } else if (this.typeValue === 'ADQ扫码登录') {
          const data = await adqShouQuan({
            cancelToken: new axios.CancelToken(c => {
              this.source = c
            })
          })
          src = data.data.data
        }
        ronyu(src)
      } catch (err) {
        this.source && this.source()
        callback('err')
      }

      function ronyu(src) {
        const img = new Image()
        const src1 = 'data:image/png;base64,' + src
        img.src = src1
        img.onload = () => {
          callback(src1)
        }
      }
    },
    reset(callback) {
      callback()
      this.source && this.source()
    },

    // 清除
    eliminate() {
      this.$prompt('<span style="color:red;">请确认是否删除，删除后将无法恢复</span>', '清除账号', {
        dangerouslyUseHTMLString: true, // 允许 HTML
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '请输入密码'
      }).then(({ value }) => {
        if (!value) {
          return this.$message.error('需要输入密码')
        }
        eliminate({ password: md5(value) }).then(res => {
          console.log(res)
          this.getAdvertiserList()
        })
      }).catch(() => {
        console.log('取消操作')
      })
      // this.$confirm('你确定是否清除账号?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async() => {
      //   await eliminate()
      //
      //   this.$message({
      //     type: 'success',
      //     message: '删除成功!'
      //   })
      //   this.getAdvertiserList()
      // })
    },
    addadvr() {
      this.dialogVisibleadr = true
      this.$nextTick(() => {
        this.$refs.addadview.send()
      })
    },
    updata() {
      this.dialogVisibleadr = false
      this.getAdvertiserList()
    },
    editepiwek() {
      this.dialogVisibleremark = true
    },
    companycallback() {
      this.dialogVisibleremark = false
      this.getAdvertiserList()
    },
    editeptag() {
      this.dialogVisibletag = true
    },
    tagcompanycallback() {
      this.dialogVisibletag = false
      this.getAdvertiserList()
    },
    multipleChoice(arr) {
      console.log('arr:', arr)
      this.account_ids = arr.map(item => {
        return item.account_id
      })
      this.account_item = arr
      console.log(this.account_ids, 11, this.account_item)
    },
    getRowKeys(row) {
      return row.account_id
    },
    deleteADList() {
      this.del_ad_visible = true
    },
    editPriceList() {
      this.ed_price_visible = true
    },
    editPeoplesList() {
      this.ed_peo_visible = true
    },
    deleteAd() {
      this.del_visible = true
    },
    handleClick(val) {
      console.log(val)
    },
    commitDelIds() {
      this.buto_loading = true
      setTimeout(function() {
        this.buto_loading = false
      }, 2000)
      stopCopyAd({
        account_ids: this.account_ids
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.del_ad_visible = false
            this.account_ids = []
            this.account_item = []
            this.buto_loading = false
          }
          console.log(res)
        })
        .catch(err => {
          this.buto_loading = false
          console.log(err)
        })
    },
    handleEditPriceSuccess() {
      this.account_ids = []
      this.account_item = []
    },
    updAdCustom() {
      if (this.custom_ids.length === 0) {
        return this.$message.error('请正确填写排除人群包')
      }
      this.buto_loading = true
      setTimeout(function() {
        this.buto_loading = false
      }, 2000)
      updAdCustom({
        account_ids: this.account_ids,
        custom_ids: this.custom_ids.split(',').map(Number)
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.ed_peo_visible = false
            this.account_ids = []
            this.custom_ids = []
            this.buto_loading = false
          }
          console.log(res)
        })
        .catch(err => {
          this.buto_loading = false
          console.log(err)
        })
    },
    delAdCustom() {
      this.password_visible = true
    },
    passwordCommit() {
      if (!this.mima) {
        return this.$message.error('请填写密码')
      }
      this.buto_loading = true
      setTimeout(function() {
        this.buto_loading = false
      }, 2000)
      delAdCustom({
        account_ids: this.account_ids,
        password: md5(this.mima)
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.del_visible = false
            this.account_ids = []
            this.custom_ids = []
            this.buto_loading = false
            this.password_visible = false
          }
          console.log(res)
        })
        .catch(err => {
          this.buto_loading = false
          console.log(err)
        })
    },
    delAd(val) {
      this.account_item = this.account_item.filter(item => {
        return item.account_id !== val.account_id
      })
      this.account_ids = this.account_ids.filter(item => {
        return item !== val.account_id
      })
      if (this.account_ids.length === 0) {
        this.del_ad_visible = false
        this.ed_price_visible = false
        this.ed_peo_visible = false
      }
    },
    emblur() {
      this.custom_ids = this.custom_ids.replace(/\n/g, ',').replace(/\s+/g, '').replace(/[，]/g, ',')
    },
    BatchRecording() {
      console.log(1)
      this.$router.push({ path: '/sendlink/index', query: {}})
    },
    link() {
      console.log(11)
      this.$router.push({ path: '/editAD/components/details', query: {}})
    },
    zijinzhanghu(val) {
      this.fund_table_data = []
      this.fund_visible = true
      console.log(val.account_id)
      getFunds({ account_id: val.account_id }).then(res => {
        this.fund_table_data = res.data
        console.log(res)
      })
    },
    Batchremoval() {
      console.log('this.account_ids', this.account_ids)
      this.batchremovaldialogVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.bathremovacompantview.send(this.account_ids)
      }, 100)
    },
    upbAdFeekBack() {
      this.updAdFeedbackVisible = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.updAdFeedback.send(this.account_ids)
      }, 100)
    },
    upbAdLog() {
      this.upd_ad_log_visible = true
    },
    openDelAdsByProductLog() {
      this.$router.push({ name: 'tencentADDelAdsByProductLog' })
    },
    management() {
      this.$router.push({
        name: 'management'
      })
    },
    billmeasure() {
      this.$router.push({
        name: 'billmeasure'
      })
    },
    exportQuery() {
      console.log(this.advertisersQuery)
      exportAccount(this.advertisersQuery).then((res) => {
        console.log(res)
        if (res.code === 0) {
          this.$message.success(res.message)
        }
      })
    },
    callbatchremova() {
      this.batchremovaldialogVisible = false
      this.account_ids = []
      this.$refs.multipleTable.clearSelection()
      this.getAdvertiserList()
    },
    updAdFeedback(val) {
      console.log(val)
      this.updAdFeedbackVisible = false
      this.$refs.multipleTable.clearSelection()
      this.account_ids = []
      this.getAdvertiserList()
    },
    exportmoneylist() {
      this.upd_monrylist = true
    },
    fundupdata() {
      this.upd_monrylist = false
    },
    realnametoken() {
      userauthorizeurl().then((res) => {
        console.log('res', res.data.url)
        window.open(res.data.url)
        // this.tokeniframe = res.data.url
        // this.realnametokendialog = true
      })
    },
    dfawerqw() {
      userauthorizeexpire().then((res) => {
        this.shiobj = res.data
        console.log('res', res.data)
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .block {
  justify-content: left;
}
.searchContainer {
  display: flex;
  font-size: 14px;
  float: left;
  margin-right: 30px;
  label {
    padding-top: 10px;
    vertical-align: middle;
    font-weight: normal;
  }
  .inputLabel {
    // display: inline-block;
    width: 100px;
  }
}

.overflow {
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.filter-item {
  margin-bottom: 5px;
}
</style>
